import { Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'

import * as bus from './localBus'
import { internalEmit, internalEmitWithAck } from './socketClient'

export const fromSocketEvent = (eventName) =>
  new Observable((subscriber) => {
    const unsubscribe = bus.on(eventName, (payload) => subscriber.next(payload))
    return unsubscribe
  })

export const fromAnySocketEvent = () =>
  new Observable((subscriber) => {
    const unsubscribe = bus.onAny((event, payload) => subscriber.next({ event, payload }))
    return unsubscribe
  })

export const emit = (eventName, payload) => {
  internalEmit(eventName, payload)
}

export const emitWithAck = (eventName, payload, timeoutMs = 5000) =>
  new Observable((subscriber) => {
    let cancelled = false
    internalEmitWithAck(eventName, payload, timeoutMs)
      .then((response) => {
        if (cancelled) return
        subscriber.next(response)
        subscriber.complete()
      })
      .pipe(
        catchError((err) => {
          if (cancelled) return
          subscriber.error(err)
        })
      )
    return () => {
      cancelled = true
    }
  })
